import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import MuiButton from '@material-ui/core/Button';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

import { useTranslation } from 'utils/modifiedTranslation';
import useStyles from './styles';

/**
 * A button the has a previous icon and a label
 */
const ArrowBackwardButton = (props) => {
  const { t } = useTranslation();
  const {
    label, onClick, isDisabled, rootClassName,
  } = props;
  const { appConfiguration: { providerSpecific } = {} } = useSelector((state) => state) ?? {};
  const provider = providerSpecific?.code;
  const classes = useStyles({ provider });

  return (
    <MuiButton className={`${classes.root} ${rootClassName}`} onClick={onClick} color="primary" disabled={isDisabled}>
      <ArrowBackIosIcon
        fontSize={provider ? 'small' : 'medium'}
        color={isDisabled ? 'disabled' : provider ? '#0C9BED' : 'primary'}
      />
      {t(label)}
    </MuiButton>
  );
};

ArrowBackwardButton.propTypes = {
  /**
   * Label of the button. If not passed then only icon will be displayed
   */
  label: PropTypes.string,
  /**
   * Function to call when button clicked
   */
  onClick: PropTypes.func.isRequired,
  /**
   * Should disable the button
   */
  isDisabled: PropTypes.bool,
  /**
   * Additional class
   */
  rootClassName: PropTypes.string,
};

ArrowBackwardButton.defaultProps = {
  rootClassName: '',
};

export default ArrowBackwardButton;
